import type { BaseUserMeta, JsonObject } from '@liveblocks/client';
import type { WithLiveblocks } from '@liveblocks/redux';
import { createSlice } from '@reduxjs/toolkit';

// Work around opinionated combineReducers behavior by creating a dummy reducer.
// https://github.com/liveblocks/liveblocks/issues/1644

const initialState: WithLiveblocks<Record<string, never>, JsonObject, BaseUserMeta>['liveblocks'] =
  {
    isStorageLoading: true,
    others: [],
    status: 'initial',
  };

const liveblocksSlice = createSlice({
  name: 'liveblocks',
  initialState,
  reducers: {
    clear: state => {
      state.isStorageLoading = initialState.isStorageLoading;
      state.status = initialState.status;
    },
  },
});

export const { clear } = liveblocksSlice.actions;

export const liveblocksReducer = liveblocksSlice.reducer;
